import { cisFile, cisFolder } from '@coreui/icons-pro'
import CIcon from '@coreui/icons-react'
import { CCol, CPlaceholder, CRow, CTable, CTableBody, CTableDataCell, CTableHead, CTableHeaderCell, CTableRow } from '@coreui/react-pro'
import { useContext, useEffect, useState } from 'react';
import { IReportNeraca } from '../../types/entities/report';
import { useSearchParams } from 'react-router-dom'
import api from '../../utils/api';
import { GenericErrorHandler } from '../../utils/misc';
import useToast from '../../hooks/toast';
import { AppContext } from '../../contexts/App';
import Censor from '../../components/Censor';
import { REPORTS_SUMMARYAKUN } from '../../constants/endpoint';

export default function SummaryAkun() {
    const [searchParams] = useSearchParams();
    const [data, setData] = useState<IReportNeraca>()
    const [loading, setloading] = useState(true)
    const [addToast] = useToast()

    useEffect(() => {
        setloading(true)
        api.get(`${REPORTS_SUMMARYAKUN}?${searchParams.toString()}`).then(onfulfilled => {
            setData(onfulfilled.data)
            setloading(false)
        }).catch(reason => {
            GenericErrorHandler({ reason, addToast })
        });
    }, [searchParams, addToast])

    if (loading) return (
        <CPlaceholder animation="glow">
            <CPlaceholder xs={12} size="lg" />
        </CPlaceholder>
    )

    return (<>
        <CRow className='d-md-none'>
            <CCol xs={12} className='mb-3'>
                <span><CIcon icon={data?.is_sub ? cisFolder : cisFile} className='me-2' />{data?.full_name}</span>
            </CCol>
            <CCol xs={12}>
                <span className='text-success'>
                    Total Debit (Rp,-)
                </span>
                <span className='float-end text-success'>
                    <Censor data={new Intl.NumberFormat('id-ID').format(data?.total_debit || 0)} />
                </span>
            </CCol>
            <CCol xs={12}>
                <span className='text-danger'>
                    Total Kredit (Rp,-)
                </span>
                <span className='float-end text-danger'>
                    <Censor data={new Intl.NumberFormat('id-ID').format(data?.total_kredit || 0)} />
                </span>
            </CCol>
            <CCol xs={12}>
                <span>
                    Subtotal (Rp,-)
                </span>
                <span className='float-end'>
                    <Censor data={new Intl.NumberFormat('id-ID').format((data?.total_debit || 0) - (data?.total_kredit || 0))} />
                </span>
            </CCol>
        </CRow>
        <CTable className='d-none d-md-table' hover>
            <CTableHead>
                <CTableRow>
                    <CTableHeaderCell>Akun</CTableHeaderCell>
                    <CTableHeaderCell className='text-end'>Total Debit (Rp,-)</CTableHeaderCell>
                    <CTableHeaderCell className='text-end'>Total Kredit (Rp,-)</CTableHeaderCell>
                    <CTableHeaderCell className='text-end'>Subtotal (Rp,-)</CTableHeaderCell>
                </CTableRow>
            </CTableHead>
            <CTableBody>
                <CTableRow>
                    <CTableDataCell><CIcon icon={data?.is_sub ? cisFolder : cisFile} className='me-2' />{data?.full_name}</CTableDataCell>
                    <CTableDataCell>
                        <span className='float-end text-success' >
                            <Censor data={new Intl.NumberFormat('id-ID').format(data?.total_debit || 0)} />
                        </span>
                    </CTableDataCell>
                    <CTableDataCell>
                        <span className='float-end text-danger' >
                            <Censor data={new Intl.NumberFormat('id-ID').format(data?.total_kredit || 0)} />
                        </span>
                    </CTableDataCell>
                    <CTableDataCell>
                        <span className='float-end' >
                            <Censor data={new Intl.NumberFormat('id-ID').format((data?.total_debit || 0) - (data?.total_kredit || 0))} />
                        </span>
                    </CTableDataCell>
                </CTableRow>
            </CTableBody>
        </CTable>
    </>)
}

